import { MinionName } from './minion-name';
import type { MinionOutput } from './types';

/**
 * Filters minion outputs to exclude the search minion.
 * The search minion data is displayed separately in the search results panels.
 */
export const filterNonSearchMinions = (
	minionOutputs: MinionOutput[] | undefined,
): MinionOutput[] => {
	if (!Array.isArray(minionOutputs)) {
		return [];
	}
	return minionOutputs.filter((minion) => {
		const minionInfo = Array.isArray(minion) ? minion[0] : minion;
		return !minionInfo.minion_id?.toLowerCase().includes(MinionName.SEARCH);
	});
};
